export const ADD_NOTE = "ADD_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const EDIT_NOTE = "EDIT_NOTE";
export const LOAD_NOTES = "LOAD_NOTES";
export const CROSS_NOTE = "CROSS_NOTE";
